/**
 * 一覧行の状態（投稿者本人は常に read）
 * - unread: 投稿を一度も開いていない
 * - post_edited: 開いたあとにタイトル・本文等が更新された
 * - new_comments: 他人からの新規コメントがある
 * - read: 既読
 */
export type BulletinReadState = 'unread' | 'post_edited' | 'new_comments' | 'read';

/** 掲示板一覧の1件 */
export type BulletinListItem = {
  id: number;
  title: string;
  author_staff_id: number;
  author_display_name: string;
  author_avatar_url: string | null;
  body_preview: string;
  created_at: string;
  updated_at: string;
  /** 表示期限（null = 無期限） */
  display_expires_at: string | null;
  /** unread / post_edited / new_comments / read */
  bulletin_read_state: BulletinReadState;
  /** bulletin_read_state が read 以外 */
  is_unread: boolean;
  /** ログイン職員が本文メンションされている */
  is_mentioned_to_me?: boolean;
};

export type BulletinPostsListResponse = {
  posts: BulletinListItem[];
  total: number;
  page: number;
  limit: number;
  total_pages: number;
};

/** 掲示板一覧・詳細の定期再取得間隔（ミリ秒） */
export const BULLETIN_POLL_INTERVAL_MS = 30_000;

export type BulletinAttachmentRow = {
  id: number;
  s3_key: string;
  original_filename: string;
  content_type: string;
  byte_size: number;
  sort_order: number;
  created_at: string;
};

export type BulletinReaderRow = {
  staff_user_id: number;
  display_name: string;
  reader_avatar_url: string | null;
  read_at: string;
};

export type BulletinPostDetail = {
  id: number;
  title: string;
  body: string;
  author_staff_id: number;
  author_display_name: string;
  author_avatar_url: string | null;
  created_at: string;
  updated_at: string;
  /** 本文・添付・メンション等の最終更新（コメント活動とは独立） */
  content_updated_at: string;
  /** 表示期限（null = 無期限） */
  display_expires_at: string | null;
};

/** スタンプ1種別の集計（詳細 API） */
export type BulletinStampBucket = {
  count: number;
  users: { staff_user_id: number; display_name: string; avatar_url: string | null }[];
};

export type BulletinStampsResponse = {
  stamps: Record<string, BulletinStampBucket>;
  my_stamps: string[];
};

export type BulletinDetailResponse = {
  post: BulletinPostDetail;
  attachments: BulletinAttachmentRow[];
  readers: BulletinReaderRow[];
  can_edit: boolean;
  /** stamp_type → 件数と押した職員一覧 */
  stamps?: Record<string, BulletinStampBucket>;
  /** ログイン職員が付けている stamp_type */
  my_stamps?: string[];
};

/** API 送信用の添付メタ */
export type BulletinAttachmentPayload = {
  s3_key: string;
  original_filename: string;
  content_type: string;
  byte_size: number;
};

/** 掲示板コメント（一覧 API） */
export type BulletinCommentRow = {
  id: number;
  post_id: number;
  author_staff_id: number;
  body: string;
  created_at: string;
  updated_at: string;
  author_display_name: string;
  author_avatar_url: string | null;
  stamps?: Record<string, BulletinStampBucket>;
  my_stamps?: string[];
};

export type BulletinCommentsListResponse = {
  comments: BulletinCommentRow[];
};
